import React from 'react'

export const ClockIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6181 5.968L19.0711 4.515L20.4851 5.929L19.0321 7.382C20.4678 9.17917 21.161 11.4579 20.9691 13.7501C20.7773 16.0424 19.7151 18.1742 18.0005 19.7077C16.286 21.2412 14.0494 22.0601 11.75 21.9961C9.45067 21.9321 7.26307 20.9901 5.63653 19.3635C4.00999 17.737 3.06799 15.5494 3.00398 13.25C2.93997 10.9506 3.75881 8.71402 5.29234 6.99951C6.82587 5.285 8.95767 4.22275 11.2499 4.03092C13.5422 3.83909 15.8209 4.53223 17.6181 5.968ZM12.0001 20C12.9193 20 13.8296 19.8189 14.6788 19.4672C15.5281 19.1154 16.2998 18.5998 16.9498 17.9497C17.5998 17.2997 18.1154 16.5281 18.4672 15.6788C18.819 14.8295 19.0001 13.9193 19.0001 13C19.0001 12.0807 18.819 11.1705 18.4672 10.3212C18.1154 9.47194 17.5998 8.70026 16.9498 8.05025C16.2998 7.40024 15.5281 6.88463 14.6788 6.53284C13.8296 6.18106 12.9193 6 12.0001 6C10.1435 6 8.36307 6.7375 7.05031 8.05025C5.73756 9.36301 5.00006 11.1435 5.00006 13C5.00006 14.8565 5.73756 16.637 7.05031 17.9497C8.36307 19.2625 10.1435 20 12.0001 20ZM11.0001 8H13.0001V14H11.0001V8ZM8.00006 1H16.0001V3H8.00006V1Z"
      fill="#F1F1F3"
    />
  </svg>
)
